import { inject, Injectable } from "@angular/core";
import { BadgeService } from "../http_services/badge.service";
import { BehaviorSubject, tap } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { BadgeNotifierDialogComponent } from "@shared/components/badge-notifier-dialog/badge-notifier-dialog.component";
import { IGetUnseenbadgeDto } from "@shared/model/badge/get-unseen-badge.model";

@Injectable({
    providedIn: 'root'
})

export class BadgeNotifierService {
    badgeNotifire$: BehaviorSubject<void> = new BehaviorSubject<void>(undefined);
    badgeService = inject(BadgeService);
    dialog = inject(MatDialog);

    checkForBadge() {
        return this.badgeService.getUnseenbadge().pipe(
            tap((res) => {
                if (!res.hasError && res.result.items.length > 0) {
                    this.openBadgeNotifierDialog(res.result.items);
                }
            })
        );
    }

    openBadgeNotifierDialog(data: IGetUnseenbadgeDto[]) {
        this.dialog.open(BadgeNotifierDialogComponent, {
            width: '320px',
            data
        });
    }
}